<template>
    <div id="pickingManage">
        <el-form ref="searchForm" :model="searchForm" style="width:100%" :inline="true" :label-position="labelPosition">
            <el-form-item style="margin-bottom:15px" class="hewidth">
                <el-input clearable v-model.trim="searchForm.code" placeholder="请输入领料编号"></el-input>
            </el-form-item>
            <el-form-item style="margin-bottom:15px" class="hewidth">
                <el-select filterable clearable :filter-method="PinyinMatch" @change="changePickingUser" v-model.trim="searchForm.pickingUser" placeholder="请选择领料人">
                    <el-option v-for="(item,index) in pickingUserAllList" 
                        :label="item.name" 
                        :value="item.name" 
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="margin-bottom:15px" class="hewidth">
                <el-select filterable clearable :filter-method="PinyinMatch1" @change="changeOperatorUser" v-model="searchForm.operatorUser" placeholder="请选择操作人">
                    <el-option v-for="(item,index) in operatorUserAllList" 
                        :label="item.staffName" 
                        :value="item.staffName" 
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="margin-bottom:15px" class="hewidth">
               <el-input v-model="addCode" placeholder="添加小码查询"></el-input>
            </el-form-item>
            <el-form-item class="hewidth">
                <el-select filterable v-model="searchForm.status" placeholder="状态" clearable>
                    <el-option v-for="(item,index) in statusList" 
                        :label="item.paraName" 
                        :value="item.paraValue" 
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <div class="clearfix">
            <el-form-item style="width: 30%;margin-bottom:15px">
                <el-date-picker
                    v-model="valueTime3"
                    type="daterange"
                    range-separator="-"
                    :default-time="['00:00:00', '11:59:59']"
                    start-placeholder="开始"
                    end-placeholder="结束">
                </el-date-picker>
            </el-form-item>
            
            <el-form-item class="fr" style="width: 60%">
                <el-col style="text-align:right">
                    <el-button type="primary" size="medium" @click="onSubmit('searchForm')">查询</el-button>
                <el-button type="text" @click="clearFrom()" style="width: 60px;color: #169BD5;">重置</el-button>
                    <el-button v-if="basicsAuth.pickingAdd" size="medium" type="success" @click="createOrder()">新建领料</el-button>
                    <el-button type="success" size="medium" @click="downLoad.exportExcel('tableId')">导出</el-button>
                    <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;margin-left: 30px;" @click="refresh()"></i>
                </el-col>
            </el-form-item>
        </div>
        </el-form>
        <el-card class="box-card" style="width: 100%;">
            <el-table
                id="tableId"
                :data="returnData"
                border
                :header-cell-style="{'text-align':'center'}"
                style="width: 100%"
                @row-click="goToDetail">
                <el-table-column
                    align="center"
                    prop="code"
                    label="领料编号">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="pickingUser"
                    label="领料人">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="sum"
                    label="申领数量">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="operatorUser"
                    label="操作人">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="status"
                    label="状态">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="createTime"
                    label="提交时间">
                </el-table-column>
            </el-table>
        </el-card>
        <!--分页-->
        <el-col :span="24" class="toolbar">
            <div class="pagination">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pages.page"
                    :page-sizes="[10, 20, 50, 100, 1000]"
                    :page-size="pages.pageSize"
                    layout="total, sizes, prev, pager, next,jumper"
                    :total="pages.total">
                </el-pagination>
            </div>
        </el-col>
    </div>
</template>

<script>
    let moment = require("moment");
    import PinyinMatch from 'pinyin-match'
    import {
        getPickingList,
        pickingList,
        engineerList,
        queryUser
    } from "../../api/api";
    import {getPermission} from '../../api/authRequest'

    export default {
        name: 'pickingManage',
        components: {},
        data () {
            return {
                choose:'',
                orderId:'',
                valueTime3:[],
                allOrder:'',
                activeIndex: '',
                defaultOrderStatus:'',
                addCode:"",
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
                statusList:[
                    {
                        paraName:'已确认',
                        paraValue:'YQR'
                    },
                    {
                        paraName:'暂存',
                        paraValue:'save'
                    }
                ],
                labelPosition:'left',
                searchForm:{
                    code:'',         //领料编号
                    pickingUser:'',  //领料人
                    operatorUser:'', //操作人ID
                    attribute1:'',   //提交开始时间
                    attribute2:'',   //提交结束时间
                    status:''
                },
                returnData: [],
                copy:[],
                copy1:[],
                pickingUserAllList:[],
                operatorUserAllList:[],
                basicsAuth:{
                    pickingAdd:false
                }
            }
        },
        created:function(){
            // this.$destroy();
            this.getPickingList();
            this.getPickingEngineerList();
            this.getOperatorUserAllList();
        },
        mounted () {
            this.basicsAuth.pickingAdd = getPermission("/api/picking/pickingAdd")
            // this.getPickingList();

        },
        methods: {
            //强制刷新
            changePickingUser(e){
                console.log(e);
                this.searchForm.pickingUser = e;
                this.$forceUpdate();
            },
            changeOperatorUser(e){
                console.log(e);
                this.searchForm.operatorUser = e;
                this.$forceUpdate();
            },
            //领料人拼音模糊搜索
            PinyinMatch(val){
                if(val && val.length > 0){
                    let result = [];
                    this.copy.forEach(i => {
                        let m = PinyinMatch.match(i.name,val);
                        if(m) {
                            result.push(i);
                        }
                    })
                    this.searchForm.pickingUser = val;
                    this.pickingUserAllList = result;
                }else{
                    this.pickingUserAllList = this.copy;
                    this.searchForm.pickingUser = "";
                }
            },
            //操作人拼音模糊搜索
            PinyinMatch1(val){
                if(val && val.length > 0){
                    let result = [];
                    this.copy1.forEach(i => {
                        let m = PinyinMatch.match(i.staffName,val);
                        if(m) {
                            result.push(i);
                        }
                    })
                    this.searchForm.operatorUser = val;
                    this.operatorUserAllList = result;
                }else{
                    this.operatorUserAllList = this.copy1;
                    this.searchForm.operatorUser = "";
                }
            },
            clearFrom(){
                this.searchForm = {
                    code:'',         //领料编号
                    pickingUser:'',  //领料人
                    operatorUser:'', //操作人ID
                    attribute1:'',   //提交开始时间
                    attribute2:'',   //提交结束时间
                    status:''
                };
                this.valueTime3 = []
            },
            getPickingEngineerList(){
                let para={
                        state:1,
                        status:1,
                        startRow: 1,
                        pageSize: 10000
                }
                engineerList(para).then(res => {     
                    if (res.data.status==100) {
                        this.pickingUserAllList = res.data.results.list;
                        this.copy = Object.assign(this.pickingUserAllList); //保留数据源 
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            getOperatorUserAllList(){
                queryUser({type:2}).then(res => {     
                    if (res.data.status==100) {
                        this.operatorUserAllList = res.data.results;
                        this.copy1 = Object.assign(this.operatorUserAllList); //保留数据源
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取领料管理列表
            getPickingList(){
                let para={
                    sn : this.addCode,
                    code:this.searchForm.code,                 //领料编号
                    pickingUser:this.searchForm.pickingUser,   //领料人
                    operatorUser:this.searchForm.operatorUser, //操作人ID
                    attribute1:this.searchForm.attribute1,     //提交开始时间
                    attribute2:this.searchForm.attribute2,     //提交结束时间
                    status:this.searchForm.status,
                    startRow: this.pages.page,
                    pageSize: this.pages.pageSize
                }
                pickingList(para).then(res => {     
                    if (res.data.status==100) {
                        this.returnData = res.data.results.list
                        this.returnData.forEach((item,index)=>{
                            item.createTime = this.filters.formatDate(item.createTime)
                        })
                        this.pages.total = res.data.results.total
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //金额转化函数
            addCommas:function(row,column){
                var num = row[column.property];
                var b= num.toString().replace(/\$|\,/g,'');
                if(isNaN(num))
                  num = "0";
                var sign = (num == (num = Math.abs(num)));
                num = Math.floor(num*100+0.50000000001);
                var cents = num%100;
                num = Math.floor(num/100).toString();
                if(cents<10)
                cents = "0" + cents;
                for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
                num = num.substring(0,num.length-(4*i+3))+','+
                num.substring(num.length-(4*i+3));
                return (((sign)?'':'-') + num + '.' + cents);
            },
            //时间转化函数
            dateFormat:function(row, column) {
                var date = row[column.property];
                if (date == undefined) {
                    return "";
                }
                return moment(date).format("YYYY-MM-DD");
            },
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.getPickingList()
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.getPickingList()
            },
            //查看订单
            toViewOrder(item,index) {
                this.activeIndex = index
                // console.log(item.status)
                this.defaultOrderStatus = item.status
                this.getPickingList()
            },
            //进入详情页面
            goToDetail(row) {
                console.log(row)
                if(row.status == "暂存"){
                    this.$router.push({
                        path:'/editPicking',
                        query:{
                            orderId:row.id
                        }
                    })
                }else{
                    this.$router.push({
                        path:'/pickingInfo',
                        query:{
                            orderId:row.id
                        }
                    })
                }
            },
            //新建采购订单
            createOrder() {
                this.$router.push({
                    path:'/newPicking'
                })
            },
            refresh() {
                this.activeIndex = 0;
                this.defaultOrderStatus = ''
                this.searchForm = {}
                this.getPickingList()
            },
            newSupplierSubmit() {
                alert('确认提交')
            },
            onSubmit(formname) {
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        if(this.valueTime3 == null){
                            this.searchForm.attribute1 = ''
                            this.searchForm.attribute2 = ''
                        }else if (this.valueTime3.length == 0) {
                            this.searchForm.attribute1 = ''
                            this.searchForm.attribute2 = ''
                        }else{
                            this.searchForm.attribute1 = this.moment(this.valueTime3[0]).format("YYYY-MM-DD");
                            this.searchForm.attribute2 = this.moment(this.valueTime3[1]).format("YYYY-MM-DD");
                        }
                        this.getPickingList()
                      
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            }
        },
        computed: {},
        watch: {}
    }
</script>

<style type="text/css" lang="scss" scoped>
    #pickingManage{font-size: 14px;
        .headerT{margin:10px 0 15px 0;}
        tr.el-table__row{cursor: pointer;}
        .toolbar{margin: 20px 0;}
        input.el-input__inner{padding-right:25px; }
        .el-date-editor--daterange.el-input, 
        .el-date-editor--daterange.el-input__inner, 
        .el-date-editor--timerange.el-input, 
        .el-date-editor--timerange.el-input__inner{}
        #section {margin-bottom: 15px;}
        #choose {margin: 0 auto;line-height: 24px;}
        #type {width: 100%;}
        #type li {line-height: 34px;float: left;margin-right: 10px;
          cursor: pointer;}
        #type a {margin: 0 12px 0 10px;color: #000;border:1px solid transparent;}
        #choose mark {
            position: relative;
            display: inline-block;
            height: 24px;
            line-height: 24px;
            border: 1px solid #28a5c4;
            color: #28a5c4;
            margin: -1px 5px 5px 0;
            background: none;
            padding: 0 30px 0 6px;
            text-indent: 0;
            /*top: 5px;*/
        }
        #choose mark a {
            position: absolute;
            /*top: -5px;*/
            right: 0px;
            display: inline-block;
            width: 18px;
            height: 22px;
            background: #28a5c4;
            color: #fff;
            line-height: 22px;
            font-size: 16px;
            text-align: center;
        }
        #type a.active {/*border:1px solid #1abc9c;*/color:#28a5c4;}
    }
  .hewidth {
        width: 17% !important;
      }
</style>



// WEBPACK FOOTER //
// pickingManage.vue?b860c904